const router = [
    {
        path: '/nstock',
        component: () => import('../views/Nstock/Index.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/nstock/list',
        component: () => import('../views/Nstock/List.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    }
]
export default router
